function sleep(milliseconds: number) {
	return new Promise((resolve) => setTimeout(resolve, milliseconds));
}
export class TokenBucketRateLimiter {
	maxRequests: number;
	maxRequestWindowMS: number;
	count: number = 0;
	resetTimeout: NodeJS.Timeout | null = null;

	constructor({
		maxRequests,
		maxRequestWindowMS
	}: {
		maxRequests: number;
		maxRequestWindowMS: number;
	}) {
		this.maxRequests = maxRequests;
		this.maxRequestWindowMS = maxRequestWindowMS;
		this.reset();
	}

	reset() {
		this.count = 0;
		this.resetTimeout = null;
	}

	scheduleReset() {
		if (!this.resetTimeout) {
			this.resetTimeout = setTimeout(() => this.reset(), this.maxRequestWindowMS);
		}
	}

	async acquireToken(callback: any): Promise<any> {
		if (this.count === this.maxRequests) {
			await sleep(0);
			this.scheduleReset();
			await sleep(this.maxRequestWindowMS);
			return this.acquireToken(callback);
		}

		this.count = this.count + 1;
		await sleep(0);
		return callback();
	}
}
